<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="loading-deadzone" #base>
	<div class="loading-wrapper">
		<mat-spinner [diameter]="100"></mat-spinner>
	</div>
</div>
